import { ProductOptionalFieldNameEnum } from '@inter-ikea-kompis/enums';
import { KompisDefaultFields, ProductService, ServiceFetch } from '@inter-ikea-kompis/services';
import { Buffer } from 'buffer';
export const UNAVAILABLE_PRODUCTS_KEY = 'S1Debug/UnavailableProducts';
export const dexfApiKeys = {
    pax: '5bf70f96-11aa-4773-a4dd-f67330b651ee',
    besta: '86f2d515-3a76-4195-bdab-60d072c42336',
    platsa: '4d059903-e6cc-4c12-be6a-eb33693057e0',
    eket: '79961114-8ac4-4cbc-9a8b-9faa71c2fb48',
    smastad: '0ec63d26-ddc8-496e-a13e-3fee6338379e',
    ivar: '978146f3-3069-4176-a945-460c494b7a84',
    billy: 'fec13e30-148b-441d-967a-5be851f923b1',
    bror: '5620b5c4-98b7-41c2-a8b5-765b0fd5fa96',
    kallax: 'cdb6dd5c-ec98-4e0e-8160-966dae6fa398',
    boaxel: 'a56392c3-013d-4dc0-b5a7-85618b1d9dc0',
    ladmakare: '0c872a7d-62ee-4dc8-8bfc-916ec6c41c47',
    jonaxel: '717e7bf3-0190-46d1-bbc5-2208a3f9880c',
    elvarli: '094b01b5-b441-4ed2-9142-1d84d47f8949',
    knoxhult: '1b805f40-e99e-4f26-87e7-a3f035abf0eb',
    aurdal: '58982793-fbae-488f-bf08-a8de3897b4c9'
};
export const dexfQaApiKeys = {
    pax: '5aa59f8b-1738-4dc6-b410-365d72724d8a',
    besta: 'd7533a0b-a25c-4db2-b847-091d2996fd85',
    platsa: '642e7ab7-9c19-4d04-83c1-84fe467d7960',
    eket: 'b33209d9-9a84-48f1-a8bf-6f03caa58bcc',
    smastad: '5cffedce-9f16-442c-817b-7caa5f7d01a5',
    ivar: '4f1442ac-1c0c-44f9-891e-26ca719d8e6f',
    billy: 'f0c72f73-52bc-4cdf-b828-6193b5a6c723',
    bror: 'c17afb12-3281-4456-9bda-eec11f5c6326',
    kallax: 'd84eb171-3a41-4dfa-b251-d0f2af829cbd',
    boaxel: '51420759-765d-4031-877a-a4d6a7b8b35a',
    ladmakare: 'f46ed05f-cbef-447b-abd0-28c9661ea154',
    jonaxel: '0cec2ab7-a663-4dd3-a773-7d7681348a95',
    elvarli: '829e294e-1e25-4f81-975e-ad53ac4a3682',
    knoxhult: '8bff9343-76eb-4064-877f-8a9cb8b17a72',
    aurdal: 'cc2330dc-6329-45a2-8ae3-ce02f6efaa22'
};
export const getDexfApiKeyQa = (range) => {
    switch (range) {
        case 'pax':
            return dexfQaApiKeys.pax;
        case 'platsa':
            return dexfQaApiKeys.platsa;
        case 'besta':
            return dexfQaApiKeys.besta;
        case 'eket':
            return dexfQaApiKeys.eket;
        case 'smastad':
            return dexfQaApiKeys.smastad;
        case 'ivar':
            return dexfQaApiKeys.ivar;
        case 'billy':
            return dexfQaApiKeys.billy;
        case 'bror':
            return dexfQaApiKeys.bror;
        case 'kallax':
            return dexfQaApiKeys.kallax;
        case 'boaxel':
            return dexfQaApiKeys.boaxel;
        case 'ladmakare':
            return dexfQaApiKeys.ladmakare;
        case 'jonaxel':
            return dexfQaApiKeys.jonaxel;
        case 'elvarli':
            return dexfQaApiKeys.elvarli;
        case 'knoxhult':
            return dexfQaApiKeys.knoxhult;
        case 'aurdal':
            return dexfQaApiKeys.aurdal;
        default:
            throw new Error('Unknown range.');
    }
};
export const getDexfApiKeyProd = (range) => {
    switch (range) {
        case 'besta':
            return dexfApiKeys.besta;
        case 'platsa':
            return dexfApiKeys.platsa;
        case 'pax':
            return dexfApiKeys.pax;
        case 'eket':
            return dexfApiKeys.eket;
        case 'smastad':
            return dexfApiKeys.smastad;
        case 'ivar':
            return dexfApiKeys.ivar;
        case 'billy':
            return dexfApiKeys.billy;
        case 'bror':
            return dexfApiKeys.bror;
        case 'kallax':
            return dexfApiKeys.kallax;
        case 'boaxel':
            return dexfApiKeys.boaxel;
        case 'ladmakare':
            return dexfApiKeys.ladmakare;
        case 'jonaxel':
            return dexfApiKeys.jonaxel;
        case 'elvarli':
            return dexfApiKeys.elvarli;
        case 'knoxhult':
            return dexfApiKeys.knoxhult;
        case 'aurdal':
            return dexfApiKeys.aurdal;
        default:
            throw new Error('Unknown range.');
    }
};
export const getDexfApiKey = (range, qa = false) => {
    return qa ? getDexfApiKeyQa(range) : getDexfApiKeyProd(range);
};
export var DEXFMeasureType;
(function (DEXFMeasureType) {
    DEXFMeasureType["FRAME_WIDTH"] = "00116";
    DEXFMeasureType["FRAME_WIDTH_MESH_BACKET"] = "00322";
    DEXFMeasureType["FRAME_DEPTH"] = "00117";
    DEXFMeasureType["FRAME_HEIGHT"] = "00118";
    DEXFMeasureType["THICKNESS"] = "00035";
    DEXFMeasureType["HEIGHT"] = "00041";
    DEXFMeasureType["WIDTH"] = "00047";
    DEXFMeasureType["DEPTH"] = "00044";
})(DEXFMeasureType || (DEXFMeasureType = {}));
export var DEXFColor;
(function (DEXFColor) {
    DEXFColor["BROWN"] = "10019";
    DEXFColor["BLACK"] = "10139";
    DEXFColor["WHITE"] = "10156";
    DEXFColor["BEIGE"] = "10003";
    DEXFColor["GREY"] = "10028";
    DEXFColor["YELLOW"] = "10042";
    DEXFColor["BLUE"] = "10007";
    DEXFColor["RED"] = "10124";
    DEXFColor["GREEN"] = "10033";
    DEXFColor["TURQUOISE"] = "10152";
    DEXFColor["ORANGE"] = "10112";
    DEXFColor["PINK"] = "10119";
    DEXFColor["MULTICOLOR"] = "10583";
})(DEXFColor || (DEXFColor = {}));
export var DEXFPriceUnitTypeCode;
(function (DEXFPriceUnitTypeCode) {
    DEXFPriceUnitTypeCode["packageQuantity"] = "00061";
})(DEXFPriceUnitTypeCode || (DEXFPriceUnitTypeCode = {}));
export var DEXFSalesPriceTypeCode;
(function (DEXFSalesPriceTypeCode) {
    DEXFSalesPriceTypeCode["REGULAR_PRICE"] = "RegularSalesUnitPrice";
    DEXFSalesPriceTypeCode["FAMILY_PRICE"] = "IKEAFamilySalesUnitPrice";
})(DEXFSalesPriceTypeCode || (DEXFSalesPriceTypeCode = {}));
export function getUnavailableProductIds() {
    const data = sessionStorage.getItem(UNAVAILABLE_PRODUCTS_KEY);
    const ids = data ? JSON.parse(data) : [];
    return ids;
}
const fixProductData = (products) => {
    return products.map(p => {
        const images = p.content?.media?.map((media) => {
            return {
                size: media.quality,
                url: media.url,
                typeName: media.typeName,
                sortNo: media.sortNo
            };
        }) || [];
        const random = Math.random();
        const fakePriceInformation = {
            salesPrice: [
                {
                    typeCode: 'RegularSalesUnitPrice',
                    priceInclTax: Math.round(random * 500),
                    priceExclTax: Math.round(random * 400),
                    currencyCode: 'EUR'
                }
            ]
        };
        return {
            ...p,
            content: { ...p.content, image: images, priceInformation: fakePriceInformation }
        };
    });
};
// TODO: Add support for this in Kompis instead of hacking
export const hackKompisProductService = async () => {
    const params = new URLSearchParams(location.search);
    if (!params.has('futureKey') && params.get('enableAllProducts') !== 'true') {
        return;
    }
    const token = params.has('futureKey') ? await getToken() : null;
    const original = ServiceFetch.json;
    ServiceFetch.json = function (url, options) {
        if (!url.startsWith('https://api.dexf.ikea.com/product/') &&
            !url.startsWith('https://api.dexf.ikea.com/webplanner/')) {
            return original.call(this, url, options);
        }
        options = options || {};
        const requestParams = new URLSearchParams(url.split('?')[1]);
        if (params.get('enableAllProducts') === 'true') {
            url = `https://api.dexf.ikea.com/product/v1/query`;
            requestParams.set('fields', '*');
        }
        if (token) {
            options.headers = options.headers || {};
            // @ts-ignore
            options.headers['Authorization'] = `Bearer ${token.id_token}`;
            // @ts-ignore
            options.headers['dexf-api-key'] = params.get('futureKey');
            const today = new Date();
            requestParams.set('timestamp', new Date(today.setMonth(today.getMonth() + 4)).toISOString().slice(0, 10));
            url = url.replace('/query', '/query-future');
        }
        url = `${url.split('?')[0]}?${requestParams.toString()}`;
        if (params.get('enableAllProducts') === 'true') {
            return original.call(this, url, options).then(response => {
                return { data: fixProductData(response.data) };
            });
        }
        return original.call(this, url, options);
    };
};
export async function fetchDEXFProducts(kompisSettings) {
    const productService = new ProductService(kompisSettings);
    const fields = [...KompisDefaultFields, ProductOptionalFieldNameEnum.filterAttribute];
    const articles = await productService.getApplicationProducts(fields);
    return articles
        .filter(a => a.content)
        .map((a) => ({
        ...a,
        valid: a.content?.itemNoGlobal && getUnavailableProductIds().includes(a.content.itemNoGlobal)
            ? false
            : a.valid
    }));
}
export async function fetchDEXFProductsForItemList(kompisSettings, dexfIds) {
    const productService = new ProductService(kompisSettings);
    const items = dexfIds
        .filter(id => id !== '')
        .map(dexfId => {
        const [type, id] = dexfId.split('-');
        return { type, id };
    });
    const fields = [...KompisDefaultFields, ProductOptionalFieldNameEnum.filterAttribute];
    const articles = await productService.getProducts(items, fields);
    return articles
        .filter(a => a.content)
        .map((a) => ({
        ...a,
        valid: a.content?.itemNoGlobal && getUnavailableProductIds().includes(a.content.itemNoGlobal)
            ? false
            : a.valid
    }));
}
const getToken = async () => {
    const params = new URLSearchParams(location.search);
    const apiKey = params.get('futureKey');
    const userName = params.get('futureUsername');
    const password = params.get('futurePassword');
    if (!apiKey || !userName || !password) {
        // eslint-disable-next-line no-console
        throw new Error('Need to add the query string "?futureKey={key}&futureUsername={username}&futurePassword={password}" to use future products');
    }
    const auth = Buffer.from(`${userName}:${password}`).toString('base64');
    const path = 'https://api.dexf.ikea.com/auth/v1/systemuser/token';
    const header = {
        'DEXF-API-KEY': apiKey,
        Authorization: `Basic ${auth}`
    };
    return fetch(path, {
        headers: header
    }).then(response => response.json());
};
export const saveFileToTemporaryStorage = async (fileContent, range) => {
    const path = `https://api.dexf.qa.ikeadt.com/vpc/v1/tempstorage/ar/models/glbs`;
    const header = {
        'DEXF-API-KEY': getDexfApiKey(range, true),
        'Content-type': 'text/plain'
    };
    return fetch(path, {
        method: 'POST',
        headers: header,
        body: fileContent.replace('data:application/octet-stream;base64', 'data:model/gltf-binary;base64')
    }).then(response => response.json());
};
//# sourceMappingURL=dexf.js.map